/**
 * activate element by trigger change
 * example: used for reload button on wishlist
 */
const activateOnchangeTriggers = [].slice.call(document.querySelectorAll('[data-activate-onchange-trigger]'));

// add event listener
if (activateOnchangeTriggers !== null && activateOnchangeTriggers.length > 0) {
  activateOnchangeTriggers.forEach((trigger) => {
    trigger.addEventListener('change', () => {
      const receiverID = trigger.dataset.activateOnchangeTrigger;
      const receiver = document.querySelector(`[data-activate-onchange-receiver="${receiverID}"]`);

      // activate receiver
      receiver.disabled = false;
    });
  });
}



// WEBPACK FOOTER //
// ./assets/js/components/utils.js